import axios from '../../../http';

const state = {
  model: {
    houseType: null,
    numberOfBedrooms: null,
    occupancyFrequency: null,
    modernisationLevel: null,
    heatingAndCooking: null
  },
  estimated: null
};

const getters = {};

const actions = {
  async calculate ({ state, rootState, rootGetters, commit }) {
    const switchType = rootGetters['quote/quoteType'];
    const params = {
      ...state.model,
      switchType,
      postcode: rootState.quote.postcode
    };

    const res = await axios({
      method: 'GET',
      url: '/request/estimation/usage',
      params
    });

    const { data, status } = res;

    if (status === 200) {
      return commit('updateState', {
        prop: 'estimated',
        value: data.estimatedUsageDto
      });
    }

    commit('updateState', {
      prop: 'estimated',
      value: 0
    });
  },
  reset ({ commit }) {
    commit('resetState');
  }
};

const mutations = {
  updateState (state, { prop, value }) {
    state[prop] = value;
  },
  resetState (state) {
    state.model.houseType = null;
    state.model.numberOfBedrooms = null;
    state.model.occupancyFrequency = null;
    state.model.modernisationLevel = null;
    state.model.heatingAndCooking = null;
    state.estimated = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
